import React, { useContext } from "react";
import { Link } from "react-router-dom";
import { CombinedContext } from "../../../context/combinedContext";
import translations from "../../../translations/translations";

const APP_VERSION = "1.1.0";
const BUILD_NUMBER = "1";

const AboutPage = () => {
    const { language } = useContext(CombinedContext);
    const t = translations[language].account.menu;

    return (
        <div className="account-menu">
            <div className="menu-item sf-about-version-item">
                <span>Sin Fila</span>
                <span className="menu-coming-soon">v{APP_VERSION} ({BUILD_NUMBER})</span>
            </div>
            <Link to="/account/terms" className="menu-item">
                {t.terms}
            </Link>
            <Link to="/account/privacy" className="menu-item">
                {t.privacy}
            </Link>
            <Link to="/account/refund" className="menu-item">
                {t.refund}
            </Link>
        </div>
    );
};

export default AboutPage;

// import React, { useContext } from "react";
// import { Link } from "react-router-dom";
// import { CombinedContext } from "../../../context/combinedContext";
// import translations from "../../../translations/translations";
// import "./accountAboutPage.css";

// const APP_VERSION = "1.1.0";
// const BUILD_NUMBER = "1";

// const AboutPage = () => {
//     const { language } = useContext(CombinedContext);
//     const t = translations[language].account.menu;

//     return (
//         <div className="sf-about">
//             <div className="account-menu">
//                 <div className="menu-item sf-about-version-item">
//                     <span>Sin Fila</span>
//                     <span className="menu-coming-soon">v{APP_VERSION} ({BUILD_NUMBER})</span>
//                 </div>
//                 <Link to="/account/terms" className="menu-item">
//                     {t.terms}
//                 </Link>
//                 <Link to="/account/privacy" className="menu-item">
//                     {t.privacy}
//                 </Link>
//                 <Link to="/account/refund" className="menu-item">
//                     {t.refund}
//                 </Link>
//             </div>
//         </div>
//     );
// };

// export default AboutPage;